export const SHARED_DESCRIPTOR_OPTIONS: Partial<PropertyDescriptor> = {
	writable: false,
	configurable: true,
	enumerable: true
};
